import { Outlet, useParams } from 'react-router-dom'
import { OrgSidebar, useSidebarState } from './org-sidebar'
import { ConsoleTopNav } from './top-nav'
import { MobileNav } from './mobile-nav'
import { cn } from '@/lib/utils'

export function ConsoleShell() {
  const { orgSlug } = useParams()
  const { isCollapsed } = useSidebarState()
  const hasSidebar = Boolean(orgSlug)

  return (
    <div className="min-h-screen bg-[var(--bg-base)]">
      {/* Top navigation */}
      <ConsoleTopNav />

      {/* Sidebar - only shown when org is selected */}
      {hasSidebar && <OrgSidebar />}

      {/* Mobile navigation - only shown when org is selected */}
      {hasSidebar && <MobileNav />}

      {/* Main content */}
      <main
        className={cn(
          'pt-14 transition-[padding] duration-200',
          hasSidebar && (isCollapsed ? 'lg:pl-16' : 'lg:pl-60')
        )}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
